/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
7/14/20
Irrigation Display: Display for a single irriation record
**********************************************************/
import moment from 'moment';
import React from 'react';
import PropTypes from 'prop-types';
import EngineTable from './engine_table';
import MeterTable from './meter_table';
import ValveTable from './valve_table';

const propTypes = {
  employees: PropTypes.array,
  engines: PropTypes.array,
  meters: PropTypes.array,
  valves: PropTypes.array,
  app: PropTypes.object
};

const IrrigationDisplay = ({ employees, engines, meters, valves, app, view, toDelete }) => {
  let employee = app.data.employee;
  if (!isNaN(app.data.employee) && employees.length > 0) {
    let emp = employees.find((e) => Number(e.id) === Number(app.data.employee));
    if (emp) employee = `${emp.firstName} ${emp.lastName}`;
  }
  if (!app.engineLog) return <div></div>;
  return (
    <div>
      {
        toDelete ?
          <h4 className="red-text">
            <span className="left"><b>Are you sure you want to delete the following log?</b></span><br />
          </h4>
        : <h4 className="blue-text">
            { view ? <span className="left"><u>Irrigation Log</u></span> : <span className="left"><u>Review and Submit</u></span> }
            <span className="right"><i className="material-icons medium">opacity</i></span><br />
          </h4>
      }
      <br />
      <div className="row">
        <center>
          <div className="col s6 m4 l4 xl4 b-r">
            <strong>Date</strong>
            <p>{ moment(app.data.date).format("dddd, MMMM Do YYYY") }</p>
          </div>
          <div className="col s6 m4 l4 xl4 b-r">
            <strong>Employee</strong>
            <p>{ employee }</p>
          </div>
          <div className="col s6 m4 l4 xl4 b-r">
            <strong>Notes</strong>
            <p>{ app.data.notes }</p>
          </div>
        </center>
      </div>
      <div className="row">
        <div className="col s6 m3 l3 xl3 b-r">
          <strong>Engine Hours</strong>
          <p>{ app.data.totalEngineHours }</p>
        </div>
        <div className="col s6 m3 l3 xl3 b-r">
          <strong>Meter Gallons</strong>
          <p>{ Number(app.data.totalMeterGal) * 1000000 }</p>
        </div>
        <div className="col s6 m3 l3 xl3 b-r">
          <strong>Valve Hours</strong>
          <p>{ app.data.totalValveHours }</p>
        </div>
        <div className="col s6 m3 l3 xl3 b-r">
          <strong>Valve Gallons</strong>
          <p>{ app.data.totalValveGal }</p>
        </div>
      </div>
      <hr className="irr-hr" />
      <h5 className="blue-text"><u>Engines</u></h5>
      {
        app.engineLog.length > 0 ?
          <EngineTable engines={engines} engineLog={app.engineLog} />
        : ''
      }

      <hr className="irr-hr" />
      <h5 className="blue-text"><u>Meters</u></h5>
      {
        app.meterLog.length > 0 ?
          <MeterTable meters={meters} meterLog={app.meterLog} />
        : ''
      }
      <hr className="irr-hr" />
      <h5 className="blue-text"><u>Valves</u></h5>
      {
        app.valveLog.length > 0 ?
          <ValveTable valves={valves} valveLog={app.valveLog} />
        : ''
      }
    </div>
  )
};

IrrigationDisplay.propTypes = propTypes;
export default IrrigationDisplay;



































/* END */



// WEBPACK FOOTER //
// ./src/irrigation/components/irrigation_display.js